import { AbstractApiService } from '../../services/abstract-service';
import {
  IDataFlowResponse,
  IPipelineDetailResponse,
  IPipelinesOverviewResponse,
  ITimersResponse
} from './pipelines.dto';
import {
  AzureMLKey,
  DurableApp,
  IPipelineEnvelope
} from './pipelines.model';

export interface IPipelinesService {
  getOverview: () => Promise<IPipelineEnvelope<IPipelinesOverviewResponse>>;
  getAzureMLPipeline: (
    key: AzureMLKey,
    history?: number
  ) => Promise<IPipelineEnvelope<IPipelineDetailResponse>>;
  getDurablePipeline: (
    app: DurableApp,
    orchestrator: string,
    history?: number
  ) => Promise<IPipelineEnvelope<IPipelineDetailResponse>>;
  getFunctionPipeline: (
    pipelineId: string,
    history?: number
  ) => Promise<IPipelineEnvelope<IPipelineDetailResponse>>;
  getTimers: () => Promise<IPipelineEnvelope<ITimersResponse>>;
  getDataFlow: () => Promise<IPipelineEnvelope<IDataFlowResponse>>;
}

export class PipelinesService extends AbstractApiService implements IPipelinesService {
  public getOverview = async () => {
    const { data } = await this.api.get<IPipelineEnvelope<IPipelinesOverviewResponse>>(
      '/pipelines/overview'
    );

    return data;
  };

  public getAzureMLPipeline = async (key: AzureMLKey, history = 10) => {
    const { data } = await this.api.get<IPipelineEnvelope<IPipelineDetailResponse>>(
      `/pipelines/azureml/${key}`,
      { params: { history } }
    );

    return data;
  };

  public getDurablePipeline = async (
    app: DurableApp,
    orchestrator: string,
    history = 10
  ) => {
    const { data } = await this.api.get<IPipelineEnvelope<IPipelineDetailResponse>>(
      `/pipelines/durable/${app}/${orchestrator}`,
      { params: { history } }
    );

    return data;
  };

  public getFunctionPipeline = async (pipelineId: string, history = 10) => {
    const { data } = await this.api.get<IPipelineEnvelope<IPipelineDetailResponse>>(
      `/pipelines/function/${pipelineId}`,
      { params: { history } }
    );

    return data;
  };

  public getTimers = async () => {
    const { data } = await this.api.get<IPipelineEnvelope<ITimersResponse>>(
      '/pipelines/timers'
    );

    return data;
  };

  public getDataFlow = async () => {
    const { data } = await this.api.get<IPipelineEnvelope<IDataFlowResponse>>(
      '/pipelines/data-flow'
    );

    return data;
  };
}
